import PropTypes from 'prop-types';

const Initial = {
  propTypes: PropTypes.shape({
    name: PropTypes.string,
    avatar: PropTypes.string,
    participants: PropTypes.arrayOf(PropTypes.shape({})),
    hasConversation: PropTypes.bool,
    conversationIncludesEducators: PropTypes.bool,
  }),
  defaultProps: {
    name: '',
    avatar: null,
    participants: [],
    hasConversation: false,
    conversationIncludesEducators: false,
  },
};

export default Initial;
